import { Component, OnInit } from '@angular/core';
import { StrucnoUsavrsavanje } from './strucno-usavrsavanje';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-strucno-usavrsavanje',
  templateUrl: './strucno-usavrsavanje.component.html'
})
export class StrucnoUsavrsavanjeComponent extends BaseModalContainer<StrucnoUsavrsavanje> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<StrucnoUsavrsavanje>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
   }


  ngOnInit() {
  }

}
